var $ = require('jquery');
var jQuery = $;
var Highcharts = require('highcharts/highstock');
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
$(document).ready(function () {
    var chartdata = [];
    var reqURL = "";
    reqURL = document.location.href;
    if (reqURL.indexOf("?fundcode") > 0) {
        if ($("#disclaimer-modal-box-fundname").length > 0) {
            $('.disclaimer-modal-box-fundname')[0].click();
        }
        var isncod = reqURL.split('=')[1];
        var isncode = isncod.split("#")[0];
        generateLineGraph(isncode, "1Y", "", "", false);

        //Filter Line Graph
        $('.chart-button--filters li a').on('click', function (e) {
            e.preventDefault();
            $('.line-chart .input-daterange input').val("");
            if ($(this).attr('data-filter') != 'Specificdates') {
                $('.date-picker-selection').hide();
                if ($(this).attr('data-filter') == 'All') {
                    generateLineGraph(isncode, "All", "", "", true);
                } else {
                    generateLineGraph(isncode, $(this).attr('data-filter'), "", "", false);
                }
            }
            else {
                $('.date-picker-selection').show();
            }

            //scrolling top
            if (windowWidth < 1200) {
                var divWrap = $('.line-chart .card');
                tabScrollTop(divWrap);
            }
        });

        //Generate Line Chart by date LU1105988155
        $('.line-chart .mobile-text-left button').on('click', function (e) {
            e.preventDefault();
            if ($('.line-chart .mobile-text-left input:eq(0)').val() != "" && $('.line-chart .mobile-text-left input:eq(1)').val() != "") {
                var fromdate = $('.line-chart .mobile-text-left input:eq(0)').val();
                var todate = $('.line-chart .mobile-text-left input:eq(1)').val();
                // console.log(fromdate);
                // console.log(todate);
                generateLineGraph(isncode, "", fromdate, todate, false);
            } else {
                alert('输入日期');
            }
        });

        function generateLineGraph(isncode, duration, from, to, istrue) {
            $('#chartmsg').hide();
            $(".fund-chart-loader").show();
            var tempnames = [];
            var seriesOptions = [];
            var colorSeries = ['#8B0000', '#0000CD', '#228B22', '#FF4500', '#BDB76B'];
            //$.getJSON('https://www.highcharts.com/samples/data/jsonp.php?filename=usdeur.json&callback=?', function (data) {
            if (window.location.href.indexOf("funddetails") > -1 || $('#chart3').length > 0) {
                // $.getJSON('http://dev.ogilvyone.com.sg/eastspring/data/' + filename + '?callback=?', function (data) {
                isncode = decodeURIComponent(isncode);
                //isincode= 'T-ES-CHINA A';
                filename = isncode;
                var token = $('input[name="__RequestVerificationToken"]').val();
                if (filename != null) {
                    var tarurl = window.location.pathname + "/Get_NAVData";
                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        data: { __RequestVerificationToken: token, isincode: filename, period: duration, fromdate: from, todate: to },
                        url: tarurl,
                        success: function (data) {
                            var datanav = [];
                            var finalnav = [];
                            if (data.length > 0) {
                                $(".fund-chart-loader").hide();
                                tempnames = [];
                                for (var d = 0; d < data.length; d++) {
                                    var tempnav = [];

                                    var seriesData = data[d];
                                    for (i = 0; i < seriesData.length; i++) {
                                        if (i == 0) {
                                            tempnames.push(seriesData[i][2]);
                                        }

                                        datanav = [];
                                        if (seriesData[i] != undefined) {

                                            var epochdt = Number(seriesData[i][0])
                                            var myDate = new Date(epochdt);
                                            datanav.push(myDate.setFullYear(myDate.getFullYear() + 543), parseFloat(seriesData[i][1].toString().replace(',', '')));
                                            tempnav.push(datanav);
                                        }
                                    }
                                    //console.log(tempnames.length);
                                    seriesOptions[d] = {
                                        name: tempnames[d],
                                        data: tempnav,
                                        turboThreshold: 0,
                                        color: colorSeries[d]
                                    };
                                }
                                if (tempnames.length == 0) {
                                    $('#chart3').hide();
                                    $('#chartmsg').show();
                                    $(".fund-chart-loader").hide();
                                }
                                else {
                                    $('#navchartid').show();
                                    $(".fund-chart-loader").hide();
                                }
                                Highcharts.setOptions({
                                    lang: {
                                        printChart: 'Print Chart',
                                        downloadPNG: 'ดาวน์โหลดไฟล์ภาพ PNG',
                                        downloadCSV: 'ดาวน์โหลด CSV',
                                        downloadXLS: 'ดาวน์โหลด XLS',
                                        viewData: 'ดูข้อมูลจากตาราง'
                                    }
                                });
                                var chart = new Highcharts.stockChart({
                                    chart: {
                                        renderTo: 'chart3'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    rangeSelector: {
                                        enabled: false
                                    },
                                    colors: ['#fdbc34'],
                                    title: {
                                        text: 'ผลการดำเนินงาน ราคา',
                                        style: {
                                            display: 'none'
                                        }
                                    },
                                    xAxis: {
                                        type: 'datetime',
                                        crosshair: {
                                            color: '#fdbc34'
                                        },
                                        lineColor: '#babcbe'
                                    },
                                    yAxis: {
                                        opposite: false,
                                        title: {
                                            text: 'ผลการดำเนินงาน'
                                        },
                                        gridLineColor: '#ffffff',
                                        lineWidth: 1,
                                        lineColor: '#babcbe',
                                        labels: {
                                            format: '{value:.2f}',
                                            formatter: function () {
                                                return Highcharts.numberFormat(this.value, 2, ',');
                                            }
                                        },
                                    },
                                    tooltip: {
                                        formatter: function () {
                                            if (this.point) {
                                                var title = this.point.title
                                                return title;
                                            } else {
                                                tip = Highcharts.dateFormat('%d/%m/%Y', this.x)
                                                if (this.points.length > 2) {
                                                    tip = tip + '<br>' +
                                                        '<span style="color:' +
                                                        this.points[2].series.color +
                                                        '">\u25CF </span>' +
                                                        this.points[2].series.name +
                                                        ': ' +
                                                        Highcharts.numberFormat(this.points[2].y, 2, ',', ',') +
                                                        '<br>' +
                                                        '<span style="padding-left:1em,text-indent:-1em"><span style="color:' +
                                                        this.points[1].series.color +
                                                        '">\u25CF </span>' +
                                                        this.points[1].series.name +
                                                        ': ' +
                                                        Highcharts.numberFormat(this.points[1].y, 2, ',', ',') +
                                                        '</sapn><br>' +
                                                        '<span style="color:' +
                                                        this.points[0].series.color +
                                                        '">\u25CF </span>' +
                                                        this.points[0].series.name +
                                                        ': ' +
                                                        Highcharts.numberFormat(this.points[0].y, '2', '.');
                                                }
                                                else if (this.points.length > 1) {
                                                    tip = tip + '<br>' +
                                                        '<span style="padding-left:1em,text-indent:-1em"><span style="color:' +
                                                        this.points[1].series.color +
                                                        '">\u25CF </span>' +
                                                        this.points[1].series.name +
                                                        ': ' +
                                                        Highcharts.numberFormat(this.points[1].y, 2, ',', ',') +
                                                        '</sapn><br>' +
                                                        '<span style="color:' +
                                                        this.points[0].series.color +
                                                        '">\u25CF </span>' +
                                                        this.points[0].series.name +
                                                        ': ' +
                                                        Highcharts.numberFormat(this.points[0].y, '2', '.');
                                                }
                                                else if (this.points.length > 0) {
                                                    tip = tip + '<br>' +
                                                        '<span style="color:' +
                                                        this.points[0].series.color +
                                                        '">\u25CF </span>' +
                                                        this.points[0].series.name +
                                                        ': ' +
                                                        Highcharts.numberFormat(this.points[0].y, '2', '.');
                                                }
                                                return tip;
                                            }
                                        }
                                    },
                                    legend: {
                                        enabled: true
                                    },
                                    plotOptions: {
                                        series: {
                                            marker: {
                                                enabled: false,
                                                states: {
                                                    hover: {
                                                        enabled: true,
                                                        radius: 3
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    series: seriesOptions,
                                    responsive: {
                                        rules: [{
                                            condition: {
                                                maxWidth: 500
                                            },
                                            chartOptions: {
                                                chart: {
                                                    height: 300
                                                },
                                                subtitle: {
                                                    text: null
                                                },
                                                navigator: {
                                                }
                                            }
                                        }]
                                    }
                                });
                            }
                            else {
                                $(".fund-chart-loader").hide();
                                if (istrue == false) {
                                    $('#poploader').hide();
                                    $('#chart3').hide();
                                    $('#chartmsg').show();
                                    $('#navchartid').show();
                                }
                                else {
                                    $('#navchartid').hide();

                                }
                            }
                        },
                        error: function () {
                            $(".fund-chart-loader").hide();
                        },
                        complete: function () {
                            $(".fund-chart-loader").hide();
                        }


                    });
                }
            }
        }
    }
    $('#txtfromDate').datepicker({
        autoclose: true,
        endDate: new Date()
    }).on('changeDate', function (e) {
        //on change of date on start datepicker, set end datepicker's date
        $('#txttoDate').datepicker('setStartDate', e.date)
    });

    $("#txttoDate").datepicker({
        autoclose: true,
        endDate: new Date()
    });
    $('#txtFrom').datepicker({
        autoclose: true,
        endDate: new Date()
    }).on('changeDate', function (e) {
        //on change of date on start datepicker, set end datepicker's date
        $('#textTo').datepicker('setStartDate', e.date)
    });

    $("#textTo").datepicker({
        autoclose: true,
        endDate: new Date()
    });

    $('#txtPerformFrom').datepicker({
        autoclose: true,
        endDate: new Date()
    }).on('changeDate', function (e) {
        //on change of date on start datepicker, set end datepicker's date
        $('#textPerformTo').datepicker('setStartDate', e.date)
    });

    $("#textPerformTo").datepicker({
        autoclose: true,
        endDate: new Date()
    });

    $('.date-picker-search').click(function (e) {
        e.preventDefault();
        var fromdate = $('#txtfromDate').val();
        var todate = $('#txttoDate').val();
        if (fromdate != "" && todate != "") {
            generateLineGraph(isncode, "", fromdate, todate, false);

        }
        else {
            alert('Input a date');
        }
    });
});
$(document).ready(function () {
    $('#moreFundObjectivebtn').click(function (e) {
        e.preventDefault();
        var x = document.getElementById("moreFundObjective");
        if (x.style.display === "none") {
            x.style.display = "inline";
            $('#moreFundObjectivebtn').text("Read less..");
        } else {
            x.style.display = "none";
            $('#moreFundObjectivebtn').text("Read more..");
        }
        //$('#moreFundObjectivebtn').text("Read less..");
        //$('#moreFundObjective').show();
    })
    $('.sg_funds').click(function (e) {
        e.preventDefault();
        // console.log('inside cookie');
        var isincode;
        var url = window.location.href;
        if (url.indexOf('?fundcode') != -1)
            var spliturl = [];
        spliturl = url.split('?fundcode=');
        if (spliturl[1].indexOf('&') != -1) {
            isincode = spliturl[1].split('&')[0];

        }
        else {
            isincode = spliturl[1];
        }
        var ab;
        ab = getCookie('FavFunds')
        if (ab == null || ab == "") {

            setCookie('FavFunds', isincode, 20);
        }
        else {
            var a = getCookie('FavFunds');

            if (a.indexOf(isincode) != -1)
                a = a;
            else
                a = a + "|" + isincode;
            if (a.length != 0) {
                a = a.replace(',', '|');
            }
            setCookie('FavFunds', a, 20);
            //console.log(getCookie('FavFunds'));

            //have cookie
        }
    });
    function setCookie(cname, cvalue, exdays) {
        var selCount = $('.badge.badge-grey.wishlist').html();
        var expires = "max-age=" + 24 * 60 * 60 * 1 * 20;
        var sel = $('.sg_funds').length;
        if (cvalue == 'defaultValue') {
            cvalue = 0;
            if (window.location.href.indexOf('https') != -1)
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + "; secure; SameSite=Lax";
            else
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

        }

        if (selCount != '0') {
            if (window.location.href.indexOf('https') != -1)
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + "; secure; SameSite=Lax";
            else
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            alert('Added successfully');
        }
        else {
            if (sel > 0) {
                if (window.location.href.indexOf('https') != -1)
                    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + "; secure; SameSite=Lax";
                else
                    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
                alert('Added successfully');

            }
            else {
                alert('Please select at least one fund.');
            }

        }




    }
    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    }
    function setSiteCookie(name, value, exdays) {
        var expires = "max-age=" + 24 * 60 * 60 * 1 * 20;
        if (window.location.href.indexOf('https') != -1)
            document.cookie = name + "=" + value + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
        else
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
    //Cookie section start 

    var siteCookieExist = getCookie("siteCookieExist");
    if (siteCookieExist != undefined) {
        if (siteCookieExist == '' || siteCookieExist == null) {
            $('#_cookieConsentWrapper').show();
        }
        else {
            $('#_cookieConsentWrapper').fadeOut(1000);
        }
    }
    else {
        $('#_cookieConsentWrapper').show();
    }
    $('#cookie-agree').click(function () {
        setSiteCookie('siteCookieExist', true, 2147483647);
        $("#_cookieConsentWrapper").fadeOut(1000);
    });
    $('.btnCancel').click(function () {
        setSiteCookie('siteCookieExist', false, 2147483647);
        $('#_cookieConsentWrapper').fadeOut(1000);
    });
    $(function () {
        var loc = window.location.href;
        if (loc.indexOf('/funddetails') > 0) {

            if ($('#Whyinvest').length == 0) {
                $(".sec-nav-list ul li a[name='Whyinvest']").parent().hide();
            }
            if ($('#Downloads').length == 0) {
                $(".sec-nav-list ul li a[name='Downloads']").parent().hide();
            }
            if ($('#Performance').length == 0) {
                $(".sec-nav-list ul li a[name='Performance']").parent().hide();
            }
            if ($('#Managers').length == 0) {
                $(".sec-nav-list ul li a[name='Managers']").parent().hide();
            }
            if ($('#Facts').length == 0) {
                $(".sec-nav-list ul li a[name='Facts']").parent().hide();
            }
            if ($('#Wheretobuy').length == 0) {
                $(".sec-nav-list ul li a[name='Wheretobuy']").parent().hide();
            }

            if ($("#Insights").length == 0) {
                $(".sec-nav-list ul li a[name='Insights']").parent().hide();
            }
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                $(".funddetails-wrapper-list").addClass("tab-scroll tab-scroll-awards");
            }
        }
    });
})

// $(document).ready(function () {
//     $("#returns-table1 tr:gt(2)").hide();
//     $("#returns-table2 tr:gt(2)").hide();
//     $("#returns-table1 tr:last").show();
//     $("#returns-table2 tr:last").show();
//     $("#ShowMore1").on('click', function (e) {
//         e.preventDefault();
//         $("#returns-table1 tr:gt(2)").show();
//         $("#ShowMore1").hide();
//     });
//     $("#ShowMore2").on('click', function (e) {
//         e.preventDefault();
//         $("#returns-table2 tr:gt(2)").show();
//         $("#ShowMore2").hide();
//     });
// });

/** Fund listing popup related js start */
$(document).ready(function () {
    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setHours(0, 0, 0, 0);
            date.setDate(date.getDate() + days);
            //date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else var expires = "";

        if (window.location.href.indexOf('https') != -1) {
            document.cookie = name + "=" + value + ";" + expires + ";path=/" + "; secure;SameSite=Lax";
        }
        else {
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        }
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    if (window.location.href.indexOf("mutual-funds") > -1) {
        if (readCookie("disclaimer") != "default") {
            $('.disclaimer-modal-box-funds')[0].click();
            $("#btn-disclaimer-close").on('click', function () {
                createCookie("disclaimer", "default", 1)
            });
        }
    }
    setTimeout(function () {
        $('.chart-button--filters.navchart button').on('click', function (e) {
            e.preventDefault();
            //$('#fund-NAVPrice-chart').show();
            $('.line-chart .input-daterange input').val("");
            var fcode = $('.btn--rounded-gold.navprice').attr('data-fundCode');
            var navtype = $('.btn--rounded-gold.navper').attr('data-navType');
            $('.chart-button--filters.navchart button').removeClass('active');
            $(this).addClass('active');
            if ($(this).attr('data-filter') == 'All') {
                if ($('.btn--rounded-gold.navprice.active').attr('data-tab') == '1') {
                    $("#poploader").show();
                    generateLineGraphpopup(fcode, "All", "", "", true, "Price", navtype);
                }
                else {
                    $("#poploader").show();
                    generateLineGraphpopup(fcode, "All", "", "", true, "Per", navtype);
                }
            } else {

                if ($('.btn--rounded-gold.navprice.active').attr('data-tab') == '1') {
                    $("#poploader").show();
                    generateLineGraphpopup(fcode, $(this).attr('data-filter'), "", "", false, "Price", navtype);
                }
                else {
                    $("#poploader").show();
                    generateLineGraphpopup(fcode, $(this).attr('data-filter'), "", "", false, "Per", navtype);
                }
            }

            //scrolling top
            // if (windowWidth < 1200) {
            //     var divWrap = $('.line-chart .card');
            //     tabScrollTop(divWrap);
            // }
        });
        $('.btn--rounded-gold.navprice').click(function (e) {
            e.preventDefault();
            $('.chart-button--filters.navchart').find('.btn--rounded-gold.active').removeClass('active')
            $('.chart-button--filters.navchart').find('.btn--rounded-gold[data-filter="YTD"]').trigger('click');
            var fcode = $(this).attr('data-fundCode')
            var navtype = $(this).attr('data-navType')
            $('.navprice').addClass('active');
            $('.navper').removeClass('active');
            $("#poploader").show();
            generateLineGraphpopup(fcode, "YTD", "", "", true, "Price", navtype);
        });
        $('.btn--rounded-gold.navper').click(function (e) {
            e.preventDefault();
            $('.navprice').removeClass('active');
            $('.chart-button--filters.navchart').find('.btn--rounded-gold.active').removeClass('active')
            $('.chart-button--filters.navchart').find('.btn--rounded-gold[data-filter="YTD"]').trigger('click');
            var fcode = $(this).attr('data-fundCode')
            var navtype = $(this).attr('data-navType')
            $('.navper').addClass('active');
            $('#fund-NAVPrice-chart').show();
            $("#poploader").show();
            generateLineGraphpopup(fcode, "YTD", "", "", true, "Per", navtype);
        });
        var flag = true;
        $('.price-graph').click(function (e) {
            flag = true;
            $('#fund-NAVPrice-chart').show();
            $("#popuploader").show();
            var fcode = $(this).attr('data-navcode');
            var navtype = $(this).attr('data-navtype');
            $("#nav-tab1").attr("data-fundCode", fcode);
            $("#nav-tab2").attr("data-fundCode", fcode);
            $("#nav-tab1").attr("data-navType", navtype);
            $("#nav-tab2").attr("data-navType", navtype);
            $("#nav-tab1").html('มูลค่าหน่วยลงทุน'); //JIRA ETH-249 update 08/11/2019
            //$("#nav-tab1").html('มูลค่าทรัพย์สินสุทธิ ราคา');
            $("#nav-tab1").show(); //JIRA ETH-249 update 08/11/2019
            $("#nav-tab2").show();
            $("#nav-tab2").html('% change of ผลตอบแทนสะสม'); //JIRA ETH-249 update 08/11/2019
            generateLineGraphpopup(fcode, "YTD", "", "", true, "Price", navtype);
        });
        $(document).on('click', '.Performance', function (e) {
            e.preventDefault();

            flag = true;
            $('#fund-NAVPrice-chart').show();
            $("#popuploader").show();
            var PertabFundCode = $(this).attr('data-navcode');
            var navtype = $(this).attr('data-navtype');
            $("#nav-tab1").attr("data-fundCode", PertabFundCode);
            $("#nav-tab2").attr("data-fundCode", PertabFundCode);
            $("#nav-tab1").attr("data-navtype", navtype);
            $("#nav-tab2").attr("data-navtype", navtype);
            $("#nav-tab1").hide();//JIRA update ETH-249 on 08/11/2019
            //$("#nav-tab1").html('ผลการดำเนินงาน ราคา'); 
            $("#nav-tab2").hide();
            $("#nav-tab2").html('% Change of ผลการดำเนินงาน');
            generateLineGraphpopup(PertabFundCode, "YTD", "", "", true, "Price", navtype);
        });
        $('#popupbtnclose').click(function (e) {
            e.preventDefault();
            flag = false;
            $('.orange-tabs-group .btn--rounded-gold').removeClass('active');
            $('.orange-tabs-group .btn--rounded-gold:eq(0)').addClass('active');
            $('.chart-button--filters.navchart').find('.btn--rounded-gold[data-filter="YTD"]').trigger('click');
        })
        function generateLineGraphpopup(isncode, duration, from, to, istrue, Charttype, navtype) {
            if (flag != false) {
                var ChartYLabel = '';
                var TooltipLabel = '';
                var tempnames = [];
                var seriesOptions = [];
                var colorSeries = ['#8B0000', '#0000CD', '#228B22', '#FF4500', '#BDB76B'];

                //JIRA update ETH-249 on 08/11/2019
                if (navtype == 'tab-Navtabprice') {
                    ChartYLabel = 'มูลค่าหน่วยลงทุน'
                    TooltipLabel = 'มูลค่าหน่วยลงทุน (บาท)';
                }
                else {
                    ChartYLabel = 'ผลการดำเนินงาน'
                    TooltipLabel = 'ผลการดำเนินงาน ราคา';
                }
                $('.pageloading').show();

                //Poup chart data for Nav & performance
                //$('#chartmsg').hide();
                $('.card.white.shadow #chartmsg').hide();
                //$.getJSON('https://www.highcharts.com/samples/data/jsonp.php?filename=usdeur.json&callback=?', function (data) {
                if ($('#fund-NAVPrice-chart').length > 0) {
                    // $.getJSON('http://dev.ogilvyone.com.sg/eastspring/data/' + filename + '?callback=?', function (data) {
                    filename = isncode;
                    seriesOptions = [];
                    var token = $('input[name="__RequestVerificationToken"]').val();
                    var tarurl = window.location.pathname + '/Get_PopupNAVData';//?__RequestVerificationToken=' + token + '&isincode=' + filename + '&period=' + duration + '&fromdate=' + from + '&todate=' + to + '&type=' + Charttype + '&navtype=' + navtype;
                    //var tarurl = '/api/FundsApi/Get_PopupNAVData?__RequestVerificationToken=' + token + '&isincode=' + filename + '&period=' + duration + '&fromdate=' + from + '&todate=' + to + '&type=' + Charttype + '&navtype=' + navtype;
                    if (filename != null) {
                        $.ajax({
                            type: "POST",
                            // dataType: 'json',
                            'async': false,
                            cache: false,
                            data: { __RequestVerificationToken: token, isincode: filename, period: duration, fromdate: from, todate: to, type: Charttype, navtype: navtype },
                            url: tarurl,
                            success: function (response) {
                                var data = JSON.parse(response);
                                var datanav = [];
                                var finalnav = [];
                                var strdt = 'Date';
                                var strlbl = 'มูลค่าหน่วยลงทุน (บาท)';
                                if (data.length > 0) {
                                    $('#fund-NAVPrice-chart').show();
                                    $('.pageloading').hide();
                                    $("#poploader").hide();
                                    $("#popuploader").hide();
                                    //$('#exampleModal-fund-list').modal('show');
                                    //
                                    if (!($("#exampleModal-fund-list").hasClass("show"))) {
                                        $('.exampleModal-fund-list')[0].click();
                                    }
                                    if (navtype == 'tab-Navtabprice') {
                                        isNav = true;
                                        finalnav1 = [];
                                        datanav = [];
                                        datanav.push(strdt.toString(), strlbl.toString());
                                        finalnav1.push(datanav);

                                        for (i = 0; i < data.length; i++) {
                                            datanav = [];
                                            var datanav1 = [];
                                            //console.log(data[i].Price);

                                            if (data[i].Price != null) {
                                                var epochdt = Number(data[i].Navdate);
                                                var myDate = new Date(epochdt);
                                                datanav.push(myDate.setFullYear(myDate.getFullYear() + 543), parseFloat(data[i].Price.toString().replace(',', '')));
                                                finalnav.push(datanav);
                                                datanav1.push(myDate, parseFloat(data[i].Price.toString().replace(',', '')));
                                                finalnav1.push(datanav1);
                                            }
                                        }
                                        //$('#exampleModal-fund-list').modal('show');
                                        seriesOptions[0] = {
                                            name: TooltipLabel,
                                            data: finalnav,
                                            turboThreshold: 0,
                                        };

                                        //console.log(tempnames);
                                    }
                                    else {
                                        isNav = false;
                                        $('.pageloading').hide();
                                        $("#poploader").hide();
                                        $("#popuploader").hide();
                                        tempnames = [];
                                        for (var d = 0; d < data.length; d++) {
                                            var tempnav = [];

                                            var seriesData = data[d];
                                            for (i = 0; i < seriesData.length; i++) {
                                                if (i == 0) {
                                                    tempnames.push(seriesData[i][2]);
                                                }
                                                datanav = [];
                                                if (seriesData[i] != undefined) {

                                                    var epochdt = Number(seriesData[i][0]);
                                                    var myDate = new Date(epochdt);
                                                    datanav.push(myDate.setFullYear(myDate.getFullYear() + 543), parseFloat(seriesData[i][1].toString().replace(',', '')));
                                                    tempnav.push(datanav);
                                                }
                                            }
                                            seriesOptions[d] = {
                                                name: tempnames[d],
                                                data: tempnav,
                                                turboThreshold: 0,
                                                color: colorSeries[d]
                                            };
                                        }
                                        if (tempnames.length == 0) {
                                            $('#fund-NAVPrice-chart').hide();
                                            $('.card.white.shadow #chartmsg').show();

                                        }


                                    }
                                    Highcharts.setOptions({
                                        lang: {
                                            printChart: 'Print Chart',
                                            downloadPNG: 'ดาวน์โหลดไฟล์ภาพ PNG',
                                            downloadCSV: 'ดาวน์โหลด CSV',
                                            downloadXLS: 'ดาวน์โหลด XLS',
                                            viewData: 'ดูข้อมูลจากตาราง'
                                        }
                                    });
                                    var chart = new Highcharts.stockChart({
                                        chart: {
                                            renderTo: 'fund-NAVPrice-chart'
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        rangeSelector: {
                                            enabled: false
                                        },
                                        colors: ['#455560'],
                                        title: {
                                            text: TooltipLabel,
                                            style: {
                                                display: 'none'
                                            }
                                        },
                                        xAxis: {
                                            type: 'datetime',
                                            crosshair: {
                                                color: '#fdbc34'
                                            },
                                            lineColor: '#babcbe'
                                        },
                                        yAxis: {
                                            opposite: false,
                                            title: {
                                                text: ChartYLabel
                                            },
                                            gridLineColor: '#ffffff',
                                            lineWidth: 1,
                                            lineColor: '#babcbe',
                                        },
                                        tooltip: {
                                            formatter: function () {
                                                if (this.point) {
                                                    var title = this.point.title
                                                    return title;
                                                } else {
                                                    tip = Highcharts.dateFormat('%d/%m/%Y', this.x)
                                                    if (this.points.length > 2) {
                                                        tip = tip + '<br>' +
                                                            '<span style="color:' +
                                                            this.points[2].series.color +
                                                            '">\u25CF </span>' +
                                                            this.points[2].series.name +
                                                            ': ' +
                                                            Highcharts.numberFormat(this.points[2].y, 2, '.') +
                                                            // + '/' + Highcharts.numberFormat(this.points[2].y, 0, ',', ',') +
                                                            '<br>' +
                                                            '<span style="padding-left:1em,text-indent:-1em"><span style="color:' +
                                                            this.points[1].series.color +
                                                            '">\u25CF </span>' +
                                                            this.points[1].series.name +
                                                            ': ' +
                                                            Highcharts.numberFormat(this.points[1].y, 2, '.') +
                                                            //+ '/' + Highcharts.numberFormat(this.points[1].y, 0, ',', ',') +
                                                            '</sapn><br>' +
                                                            '<span style="color:' +
                                                            this.points[0].series.color +
                                                            '">\u25CF </span>' +
                                                            this.points[0].series.name +
                                                            ': ' +
                                                            Highcharts.numberFormat(this.points[0].y, 2, '.');
                                                        //+'/' + Highcharts.numberFormat(this.points[0].y, '2f', '.');
                                                    }
                                                    else if (this.points.length > 1) {
                                                        tip = tip + '<br>' +
                                                            '<span style="padding-left:1em,text-indent:-1em"><span style="color:' +
                                                            this.points[1].series.color +
                                                            '">\u25CF </span>' +
                                                            this.points[1].series.name +
                                                            ': ' +
                                                            Highcharts.numberFormat(this.points[1].y, 2, '.') +
                                                            //+ '/' + Highcharts.numberFormat(this.points[1].y, 0, ',', ',') +
                                                            '</sapn><br>' +
                                                            '<span style="color:' +
                                                            this.points[0].series.color +
                                                            '">\u25CF </span>' +
                                                            this.points[0].series.name +
                                                            ': ' +
                                                            Highcharts.numberFormat(this.points[0].y, '2', '.');
                                                    }
                                                    else if (this.points.length > 0) {
                                                        if ($('.btn--rounded-gold.navprice.active').length > 0) {
                                                            tip = tip + '<br>' +
                                                                '<span style="color:' +
                                                                this.points[0].series.color +
                                                                '">\u25CF </span>' +
                                                                this.points[0].series.name +
                                                                ': ' +
                                                                Highcharts.numberFormat(this.points[0].y, 4, '.');
                                                            //+ '/' + Highcharts.numberFormat(this.points[0].y, '2f', '.');
                                                        }
                                                        else {
                                                            tip = tip + '<br>' +
                                                                '<span style="color:' +
                                                                this.points[0].series.color +
                                                                '">\u25CF </span>' +
                                                                this.points[0].series.name +
                                                                ': ' +
                                                                Highcharts.numberFormat(this.points[0].y, 2, '.');
                                                            //+ '/' + Highcharts.numberFormat(this.points[0].y, '2f', '.');
                                                        }

                                                    }

                                                    return tip;
                                                }
                                            }
                                        },
                                        legend: {
                                            enabled: true
                                        },
                                        plotOptions: {
                                            series: {
                                                marker: {
                                                    enabled: false,
                                                    states: {
                                                        hover: {
                                                            enabled: true,
                                                            radius: 3
                                                        }
                                                    }
                                                }
                                            }
                                        },

                                        series: seriesOptions,
                                        responsive: {
                                            rules: [{
                                                condition: {
                                                    maxWidth: 500
                                                },
                                                chartOptions: {
                                                    chart: {
                                                        height: 300
                                                    },
                                                    subtitle: {
                                                        text: null
                                                    },
                                                    navigator: {
                                                    }
                                                }
                                            }]
                                        }
                                    });
                                }


                                else {
                                    $('.pageloading').hide();
                                    $("#poploader").hide();
                                    $("#popuploader").hide();
                                    if (istrue == false) {
                                        $('#fund-NAVPrice-chart').hide();
                                        $('#chartmsg').show();
                                    }
                                    else {
                                        $('#fund-NAVPrice-chart').hide();
                                        // $('#chartmsg').show();
                                        $('.card.white.shadow #chartmsg').show();

                                    }
                                }
                            },
                            error: function () {
                                $('.pageloading').hide();
                                $("#poploader").hide();
                                $("#popuploader").hide();

                            },
                            complete: function () {
                                $('.pageloading').hide();
                                $("#poploader").hide();
                                $("#popuploader").hide();
                            }
                        });
                    }
                }
            }
        }
        //***fundlist page nav popups Ends here***//    

        $(document).on('click', '.tablepopup', function (e) {
            $("#Chart-fund-list-chart").hide();
            //console.log('price-pop');
            e.preventDefault();
            $(".pricepopup").hide();
            $("#popuploader").show();
            $('.price-pop').removeClass('active');
            $("#firstFilter").addClass('active');
            var isincode = $(this).attr('data-navcode');
            $(this).prop('data-content', isincode);
            $("#Chart-fund-list-chart").attr('isincode', isincode);
            var period = "3m";
            var from = "";
            var to = "";
            var Charttype = "";
            var navtype = "";
            $("#txtFrom").val('');
            $("#textTo").val('');
            $("#Chart-fund-list-chart").hide();
            LoadChartdata(isincode, period, from, to, Charttype, navtype);
        })
        $('.price-pop').on('click', function (e) {
            e.preventDefault();
            $("#popuploader").hide();
            $("#popuptableloader").show();
            var isincode = ""
            var filename = "All";
            $('.price-pop').removeClass("active");
            $(this).addClass("active");
            var from = '';//$("#txtFrom").val();
            var to = '';//$("#textTo").val();
            $("#txtFrom").val('');
            $("#textTo").val('');
            var Charttype = "";
            var period = $(this).attr('data-filter');
            var navtype = "";
            isincode = $("#Chart-fund-list-chart").attr('isincode');

            LoadChartdata(isincode, period, from, to, Charttype, navtype);
        })
        $('.performancepop').on('click', function (e) {
            e.preventDefault();
            $("#popuploader").hide();
            $("#popuptableloader").show();
            $("#popupperftableloader").show();
            //  $("#popupperformanceloader").hide();
            //   $("#popupperftableloader").show();
            $('.performancepop').removeClass("active");
            $(this).addClass("active");
            var isincode = ""
            var filename = "All";
            //var from = $("#txtFrom").val();
            //var to = $("#textTo").val();
            var from = '';
            var to = '';
            $("#txtPerformFrom").val('');
            $("#textPerformTo").val('');
            $("#textTo").removeAttr('disabled');
            isincode = $("#Chart-performance-list-chart").attr('isincode');
            var Charttype = "";
            var period = $(this).attr('data-filter');
            var navtype = "";
            LoadPerformancedata(isincode, period, from, to, Charttype, navtype);
        })

        // Event listener to the two range filtering inputs to redraw on input
        $('#txtFrom, #textTo').change(function (e) {
            e.preventDefault();
            $("#popuploader").hide();
            $("#popuptableloader").show();
            $('.price-pop').removeClass('active');
            var isincode = ""
            var filename = "All";
            //var from = $('.mobile-text-left input:eq(0)').val();
            //var to = $('.mobile-text-left input:eq(1)').val();
            var from = $('.mobile-text-left #txtFrom').val();
            var to = $('.mobile-text-left #textTo').val();
            isincode = $("#Chart-fund-list-chart").attr('isincode');
            //var d = new Date(from);
            //var year = d.getFullYear();
            //var month = d.getMonth();
            //var day = d.getDate();
            //var fakefrom= day+'-'+month+'-'+(year + 543);
            //if (to == 'undefined' || to == '') {
            //    //to = new Date(year + 1, month, day);
            //    to = (month + 1) + '/' + day + '/' + (year + 1);
            //    $('.mobile-text-left #textTo').val(to);
            //}

            var d = new Date(from);
            var year = d.getFullYear();
            var month = d.getMonth();
            var day = d.getDate();
            var fakefrom = day + '-' + (month + 1) + '-' + (year + 543);
            if (to == 'undefined' || to == '') {
                //to = new Date(year + 1, month, day);
                to = ((month + 1).length == 1 ? '0' + (month + 1) : (month + 1)) + '/' + (day.length == 1 ? '0' + day : day) + '/' + (year + 1);
                $('.mobile-text-left #textTo').val(to);
            }
            var d1 = new Date(to);
            var year1 = d1.getFullYear();
            var month1 = d1.getMonth();
            var day1 = d1.getDate();
            var faketo = day1 + '-' + (month1 + 1) + '-' + (year1 + 543);

            var Charttype = "";
            var period = "";
            var navtype = "";
            if (fakefrom != "" && faketo != "") {
                $("#popuploader").show();
                $("#textTo").removeAttr('disabled');
                LoadChartdata(isincode, period, fakefrom, faketo, Charttype, navtype);
            }
            else {
                $("#popuptableloader").hide();
            }
        });
        $('#txtPerformFrom, #textPerformTo').change(function (e) {
            e.preventDefault();
            $('.performancepop').removeClass('active');
            var isincode = ""
            var filename = "All";

            //var from = $('.mobile-text-left input:eq(0)').val();
            //var to = $('.mobile-text-left input:eq(1)').val();

            var from = $('.mobile-text-left #txtPerformFrom').val();
            var to = $('.mobile-text-left #textPerformTo').val();
            isincode = $("#Chart-performance-list-chart").attr('isincode');

            var d = new Date(from);
            var year = d.getFullYear();
            var month = d.getMonth();
            var day = d.getDate();
            var perfrom = day + '-' + (month + 1) + '-' + (year + 543);
            if (to == 'undefined' || to == '') {
                //to = new Date(year + 1, month, day);
                to = (month + 1) + '/' + day + '/' + (year + 1);
                $('.mobile-text-left #textPerformTo').val(to);
            }

            var d1 = new Date(to);
            var year1 = d1.getFullYear();
            var month1 = d1.getMonth();
            var day1 = d1.getDate();
            var perto = day1 + '-' + (month1 + 1) + '-' + (year1 + 543);


            var Charttype = "";
            var period = "";
            var navtype = "";
            if (perfrom != "" && perto != "") {
                // $("#popupperformanceloader").show();
                $("#popupperformanceloader").hide();
                $("#popupperftableloader").show();
                $("#textPerformTo").removeAttr('disabled');
                LoadPerformancedata(isincode, period, perfrom, perto, Charttype, navtype);
            }
            else {
                $("#popupperftableloader").hide();
            }
        });
        $("#Exportnavpop").click(function (e) {
            e.preventDefault();
            var token = $('input[name="__RequestVerificationToken"]').val();
            var isincode = ""
            var from = $('.mobile-text-left #txtFrom').val();
            var to = $('.mobile-text-left #textTo').val();
            isincode = $("#Chart-fund-list-chart").attr('isincode');
            var d = new Date(from);
            var year = d.getFullYear();
            var month = d.getMonth();
            var day = d.getDate();
            var fakefrom = day + '-' + (month + 1) + '-' + (year + 543);

            var d1 = new Date(to);
            var year1 = d1.getFullYear();
            var month1 = d1.getMonth();
            var day1 = d1.getDate();
            var faketo = day1 + '-' + (month1 + 1) + '-' + (year1 + 543);
            //var period="";
            var period = $(".price-pop.active").attr("data-filter");
            //isincode = $("#Chart-fund-list-chart").attr('isincode');
            setTimeout(function () {
                $.ajax({
                    type: "Post",
                    'async': false,
                    cache: false,
                    data: { __RequestVerificationToken: token, fundcode: isincode, period: period, fromdate: fakefrom, todate: faketo },
                    url: '/funds/mutual-funds/ExportToExcelChartPopup',
                    success: function (data, status, xhr) {
                        //alert("data");
                        // Remove any existing element with the id "downloadLink"
                        var existingElement = document.getElementById("downloadExcelLink");
                        if (existingElement) {
                            existingElement.parentNode.removeChild(existingElement);
                        }

                        // Create a new <a> element
                        var a = document.createElement("a");
                        a.id = "downloadExcelLink";
                        document.body.appendChild(a);

                        // Set up the download link as needed
                        var blob = new Blob([data], { type: xhr.getResponseHeader("Content-Type") });
                        var url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = xhr.getResponseHeader("Content-Disposition").split("filename=")[1];

                        // Trigger the download
                        a.click();
                        isButtonClicked = false;
                        // Release the object URL to free up resources
                        window.URL.revokeObjectURL(url);

                    },
                    error: function () {
                        // Handle errors
                    }
                }, 1000);
            });
            // $('#Exportnavpop').attr('href', "/funds/mutual-funds/ExportToExcelChartPopup?__RequestVerificationToken=" + token + "&fundcode=" + isincode + "&period=" + period + "&fromdate=" + from + "&todate=" + to);
        });
        function LoadChartdata(isincode, period, from, to, Charttype, navtype) {
            var token = $('input[name="__RequestVerificationToken"]').val();
            // $(".pricepopup").hide();
            var res1 = "";
            // $("#fund-popup-chart").children().remove();

            $.ajax({
                type: "POST",
                dataType: 'html',
                'async': false,
                cache: false,
                data: { __RequestVerificationToken: token, isincode: isincode, period: period, fromdate: from, todate: to, type: Charttype, navtype: navtype },
                url: window.location.pathname + '/PricePopUpCall',
                success: function (response) {
                    var _html = $("#fund-popup-chart");
                    $('#fund-popup-chart').html('');
                    var funditemsresult = response;
                    var stindex = funditemsresult.indexOf("<!-- Price Listing Tab Start -->");
                    var endindex = funditemsresult.indexOf("<!-- Price Listing Tab End -->");
                    var res = funditemsresult.substring(stindex, endindex);
                    $('#fund-popup-chart').html(res);
                },
                error: function () {
                    $("#popuploader").hide();
                },
                complete: function () {

                    if ($.fn.dataTable.isDataTable('#table-pop-fund')) {
                        $('#table-pop-fund').DataTable().destroy();
                        tablepop.clear();
                        tablepop.destroy();
                    }
                    tablepop = $('#table-pop-fund').DataTable({
                        dom: 'rtp',
                        scrollX: true,
                        oLanguage: {
                            sInfoFiltered: ""
                        },
                        "language":
                        {
                            "oPaginate": {
                                "sFirst": "ก่อนหน้า",
                                "sPrevious": "ก่อนหน้า",
                                "sNext": "ถัดไป",
                                "sLast": "ถัดไป"
                            }
                        },
                        "ordering": false,
                        info: true,
                        scrollCollapse: true,
                        paging: true,
                    });
                    //   $("#popuploader").hide();
                    $("#popuptableloader").hide();
                    $("#popuploader").hide();
                    $(".pricepopup").show();
                    $("#Chart-fund-list-chart").show();
                    if (!($("#Chart-fund-list-chart").hasClass("show"))) {
                        $('.Chart-fund-list-chart')[0].click();
                    }

                    $($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();
                    var len = $('#Chart-fund-list-chart .dataTables_empty').length;
                    if (len > 0) {
                        $('#Exportnavpop').addClass('disabled');
                    }
                    else { $('#Exportnavpop').removeClass('disabled'); }
                }


            });
        }
        $(document).on('click', '.table-performance-popup', function (e) {
            $("#popupperformanceloader").show();
            $("#Chart-performance-list-chart").hide();
            $(".performancepopup").hide();
            $(this).prop('data-content', isincode);
            e.preventDefault();
            var isincode = $(this).attr('data-navcode');
            $("#Chart-performance-list-chart").attr('isincode', isincode);
            $('.performancepop').removeClass('active');
            $("#yearToDate").addClass('active');
            var period = "YTD";
            var from = "";
            var to = "";
            $("#txtPerformFrom").val('');
            $("#textPerformTo").val('');
            var Charttype = "";
            var navtype = "";
            LoadPerformancedata(isincode, period, from, to, Charttype, navtype);
        })
        //  $('.tablepopup').on('click', function (e) {
        // $(document).on('click', '.tablepopup', function (e) {
        //     $("#Chart-fund-list-chart").hide();
        //     //console.log('price-pop');
        //     e.preventDefault();
        //     $(".pricepopup").hide();
        //     $("#popuploader").show();

        //     $('.price-pop').removeClass('active');
        //     $("#firstFilter").addClass('active');
        //     var isincode = $(this).attr('data-navcode');
        //     $(this).prop('data-content', isincode);
        //     $("#Chart-fund-list-chart").attr('isincode', isincode);
        //     var period = "3m";
        //     var from = "";
        //     var to = "";
        //     var Charttype = "";
        //     var navtype = "";
        //     $("#txtFrom").val('');
        //     $("#textTo").val('');
        //     $("#Chart-fund-list-chart").hide();
        //     LoadChartdata(isincode, period, from, to, Charttype, navtype);
        // })
        $("#Exportnavpop1").click(function (e) {
            e.preventDefault();
            var token = $('input[name="__RequestVerificationToken"]').val();
            var isincode = $(this).attr('data-navcode');
            var from = $('.mobile-text-left #txtPerformFrom').val();
            var to = $('.mobile-text-left #textPerformTo').val();
            isincode = $("#Chart-performance-list-chart").attr('isincode');
            var period = $(".performancepop.active").attr("data-filter");
            var d = new Date(from);
            var year = d.getFullYear();
            var month = d.getMonth();
            var day = d.getDate();
            var perfrom = day + '-' + (month + 1) + '-' + (year + 543);
            var d1 = new Date(to);
            var year1 = d1.getFullYear();
            var month1 = d1.getMonth();
            var day1 = d1.getDate();
            var perto = day1 + '-' + (month1 + 1) + '-' + (year1 + 543);
            $.ajax({
                type: "Post",
                data: { __RequestVerificationToken: token, fundcode: isincode, period: period, fromdate: perfrom, todate: perto },
                url: '/funds/mutual-funds/ExportToExcelChartperformencePopup',
                success: function (data, status, xhr) {
                    // Create a blob from the response data
                    var blob = new Blob([data], { type: xhr.getResponseHeader("Content-Type") });
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = url;
                    a.download = xhr.getResponseHeader("Content-Disposition").split("filename=")[1];
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                },
                error: function () {
                    // Handle errors
                }
            });
            // $('#Exportnavpop1').attr('href', "/funds/mutual-funds/ExportToExcelChartperformencePopup?__RequestVerificationToken=" + token + "&fundcode=" + isincode + "&period=" + period + "&fromdate=" + from + "&todate=" + to);
        });
        function LoadPerformancedata(isincode, period, from, to, Charttype, navtype) {
            var res1 = "";
            /// $("#popupperformanceloader").show();

            //   $(".performancepopup").hide();
            // $("#performance-popup-chart").show();

            var token = $('input[name="__RequestVerificationToken"]').val();
            $.ajax({
                type: "POST",
                dataType: 'html',
                data: { __RequestVerificationToken: token, isincode: isincode, period: period, fromdate: from, todate: to, type: Charttype, navtype: navtype },
                url: '/funds/mutual-funds/PerformancePopUpCall',
                success: function (response) {
                    //  var _html = $("#fund-popup-chart");
                    $('#performance-popup-chart').html('');
                    var funditemsresult = response;
                    var stindex = funditemsresult.indexOf("<!-- Performancepop Listing Tab Start -->");
                    var endindex = funditemsresult.indexOf("<!-- Performancepop Listing Tab End -->");
                    var res = funditemsresult.substring(stindex, endindex);

                    $('#performance-popup-chart').html(res);
                },
                error: function () {
                    $("#popupperformanceloader").hide();
                },
                complete: function () {
                    if ($.fn.dataTable.isDataTable('#table-performance-pop-fund')) {
                        $('#table-performance-pop-fund').DataTable().destroy();
                        tablePerformancepop.clear();
                        tablePerformancepop.destroy();
                    }
                    tablePerformancepop = $('#table-performance-pop-fund').DataTable({
                        dom: 'rtp',
                        scrollX: true,
                        oLanguage: {
                            sInfoFiltered: ""
                        },
                        "language":
                        {
                            "oPaginate": {
                                "sFirst": "ก่อนหน้า",
                                "sPrevious": "ก่อนหน้า",
                                "sNext": "ถัดไป",
                                "sLast": "ถัดไป"
                            }
                        },
                        "ordering": false,
                        info: true,
                        scrollCollapse: true,
                        paging: true,
                    });
                    $("#popupperformanceloader").hide();
                    $(".performancepopup").show();
                    $("#popupperftableloader").hide();
                    $("#Chart-performance-list-chart").show();
                    //   $("#performance-popup-chart").show();
                    if (!($("#Chart-performance-list-chart").hasClass("show"))) {
                        $('.Chart-performance-list-chart')[0].click();
                    }
                    $($.fn.dataTable.tables(true)).DataTable().columns.adjust().fixedColumns().relayout();
                    var len = $('#Chart-performance-list-chart .dataTables_empty').length;
                    if (len > 0) {
                        $('#Exportnavpop1').addClass('disabled');
                    }
                    else { $('#Exportnavpop1').removeClass('disabled'); }
                }


            });
        }
        $(document).on('click', '.graph-icon-benchmark', function () {
            var fundcode = $(this).attr('data-navcode');
            genarateBenchmark_descPopup(fundcode, "th-TH");
        });

        function genarateBenchmark_descPopup(isncode, langName) {
            $('.pageloading').show();
            if ($('#fund-benchmark').length > 0) {
                filename = isncode;
                var token = $('input[name="__RequestVerificationToken"]').val();
                var tarurl = window.location.pathname + "/Get_PopupBenchmark_desc";
                if (filename != null) {
                    $.ajax({
                        type: "POST",
                        //dataType: 'json',
                        data: { __RequestVerificationToken: token, isincode: filename, langName: langName },
                        url: tarurl,
                        success: function (data) {
                            var response = JSON.parse(data);
                            // alert(response.length);
                            //$('#exampleModal-fund-list-Benchmarkdesc').modal('show');
                            if (!($("#exampleModal-fund-list-Benchmarkdesc").hasClass("show"))) {
                                $('.exampleModal-fund-list-Benchmarkdesc')[0].click();
                            }
                            if (response.length > 0) {
                                $('.pageloading').hide();
                                var str = "<div class='row'>";
                                str += "<div class='col-md-12'>";
                                //str += "<div class='card white shadow'>";
                                str += "<div class='row'>"
                                //str += "<ul>";
                                //for (var i = 0; i < response.length; i++) {
                                //    str += "<li><div class='col-md-4'>" + response[i].BenchmarkName;
                                //    str += "</div><div class='col-md-8'> &nbsp;&nbsp;&nbsp;&nbsp;<span>" + response[i].BenchmarkDetails + "</span></div>";
                                //    str += "</li>";

                                //}
                                //str += "</ul>";

                                for (var i = 0; i < response.length; i++) {
                                    str += "<div class='form-group'>"
                                    str += "<div class='col-md-4 col-xs-4'>" + response[i].BenchmarkName;
                                    str += "</div><div class='col-md-8 col-xs-8'>" + response[i].BenchmarkDetails + "</div>";
                                    if (response[i].Disclaimer != null) {
                                        str += "<div class='col-md-12 col-xs-12' style='padding-top:20px'>" + response[i].Disclaimer + "</div>";
                                    }
                                    str += "</div>";
                                }
                                str += "";
                                str += "</div>";
                                str += "</div>";
                                str += "</div>";

                                $("#fund-benchmark").html(str);
                            }
                            else {

                                $('.pageloading').hide();
                                $("#fund-benchmark").html("<div class='row'><div class='col-md-12'>Data not avilable.<//div></div>");
                            }

                        }

                    });
                }

            }
        }
        // Fundlisting page remarks popup start here//
        $(document).on("click", ".imgPNG.remarks-des", function () {
            // $(".imgPNG.remarks-des").click(function () {

            var fundcode = $(this).attr('data-navcode');
            genarateRemarks_descPopup(fundcode, "th-TH");

        });

        function genarateRemarks_descPopup(isncode, langName) {
            $('.pageloading').show();
            var token = $('input[name="__RequestVerificationToken"]').val();
            if (window.location.href.indexOf("mutual-funds") > -1 && $('#fund-desc').length > 0) {
                filename = isncode;
                var tarurl = window.location.pathname + "/Get_PopupRemarks_desc";
                if (filename != null) {
                    $.ajax({
                        type: "POST",
                        // dataType: 'json',
                        data: { __RequestVerificationToken: token, isincode: filename, langName: langName },
                        url: tarurl,
                        success: function (data) {
                            var response = JSON.parse(data);
                            if (response.length > 0) {
                                $('.pageloading').hide();
                                //$('#exampleModal-fund-list-desc').modal('show');
                                if (!($("#exampleModal-fund-list-desc").hasClass("show"))) {
                                    $('.exampleModal-fund-list-desc')[0].click();
                                }
                                var str = "<div class='row'>";
                                str += "<div class='col-md-12'>";
                                str += "<div class='row'>"
                                str += "<ul>";
                                for (var i = 0; i < response.length; i++) {
                                    str += "<li>" + response[i].Sequence;
                                    str += " &nbsp;&nbsp;&nbsp;&nbsp;<span>" + response[i].RemarkDetail + "</span>";
                                    str += "</li> <br/>";
                                }
                                str += "</ul>";


                                str += "</div>";
                                str += "</div>";

                                str += "</div>";
                                str += "</div>";
                                str += "</div>";
                            }
                            $("#fund-desc").html(str);
                        }

                    });
                }

            }
        }

        $(document).on("click", ".imgPNG.tfund-remarks-des", function () {
            // $(".imgPNG.remarks-des").click(function () {

            var fundcode = $(this).attr('data-navcode');
            var navPerUnit = $(this).attr('data-nav-perunit');
            var navDt = $(this).attr('data-nav-dt');
            var navVal = $(this).attr('data-nav-val');

            $('#tnav-dt').text(navDt);
            $('#tnav-val').text(navPerUnit);
            $('#nav-perUnit').text(navVal);

            genarateTFundRemarks_descPopup(fundcode, "th-TH");

        });
        function genarateTFundRemarks_descPopup(isncode, langName) {
            $('.pageloading').show();
            var token = $('input[name="__RequestVerificationToken"]').val();
            if (window.location.href.indexOf("mutual-funds") > -1 && $('#fund-desc').length > 0) {
                filename = isncode;
                var tarurl = window.location.pathname + "/Get_TFund_PopupRemarks_desc";
                if (filename != null) {
                    $.ajax({
                        type: "POST",
                        //dataType: 'json',
                        data: { __RequestVerificationToken: token, isincode: filename, langName: langName },
                        url: tarurl,
                        success: function (data) {
                            var response = JSON.parse(data);
                            $('.pageloading').hide();
                            //console.log(response);
                            //if (response.length > 0) {
                            //    console.log(response);
                            $('.pageloading').hide();
                            //$('#exampleModal-tfund-list-desc').modal('show');
                            if (!($("#exampleModal-tfund-list-desc").hasClass("show"))) {
                                $('.exampleModal-tfund-list-desc')[0].click();
                            }
                            $('#exampleModal-tfund-list-desc .fundName').text(response.Table1[0].fund_name_th_th);

                            var offerData = '';
                            var bidData = '';
                            for (var item = 0; item < response.Table.length; item++) {

                                if (response.Table[item].TYPE == "B") {
                                    bidData = bidData + '<tr>';
                                    bidData = bidData + '<td>';
                                    bidData = bidData + response.Table[item].NOTE_THAI;
                                    bidData = bidData + '</td>';

                                    bidData = bidData + '<td>';
                                    bidData = bidData + response.Table[item].NAV;
                                    bidData = bidData + '</td>';
                                    bidData = bidData + '</tr>';
                                }
                                else {
                                    offerData = offerData + '<tr>';
                                    offerData = offerData + '<td>';
                                    offerData = offerData + response.Table[item].NOTE_THAI;
                                    offerData = offerData + '</td>';

                                    offerData = offerData + '<td>';
                                    offerData = offerData + response.Table[item].NAV;
                                    offerData = offerData + '</td>';
                                    offerData = offerData + '</tr>';
                                }

                            }

                            $('#o-tbody').html(offerData);
                            $('#b-tbody').html(bidData);





                            //    var str = "<div class='row'>";
                            //    str += "<div class='col-md-12'>";
                            //    str += "<div class='row'>";
                            //    str += "<h1> TFund </h1>";
                            //    str += "<ul>";
                            //    //for (var i = 0; i < response.length; i++) {
                            //    //    str += "<li>" + response[i].Sequence;
                            //    //    str += " &nbsp;&nbsp;&nbsp;&nbsp;<span>" + response[i].RemarkDetail + "</span>";
                            //    //    str += "</li> <br/>";
                            //    //}
                            //    str += "</ul>";


                            //    str += "</div>";
                            //    str += "</div>";

                            //    str += "</div>";
                            //    str += "</div>";
                            //    str += "</div>";
                            //}
                            //$("#tfund-desc").html(str);
                        }

                    });
                }

            }
        }



        // Fundlisting page remarks popup ends here//
    }, 3000);

});
/** Fund listing popup related js end */
$(".ExportToExcelDivedend").click(function (e) {
    e.preventDefault();
    var token = $('input[name="__RequestVerificationToken"]').val();
    var isincodes = $(this).attr("data-codes");
    $.ajax({
        type: "Post",
        data: { __RequestVerificationToken: token, isincodes: isincodes },
        url: '/funds/mutual-funds/ExportToExcelDivedend',//?__RequestVerificationToken=' + token + '&isincodes=' + isincodes,
        success: function (data, status, xhr) {
            // Create a blob from the response data
            var blob = new Blob([data], { type: xhr.getResponseHeader("Content-Type") });
            // Create a temporary link and trigger a click event to download the file
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = xhr.getResponseHeader("Content-Disposition").split("filename=")[1];
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        },
        error: function () {
            // Handle errors
        }
    });
});